import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

const GALLERY_ITEMS = [
  {
    id: 1,
    src: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=900&q=80&auto=format&fit=crop',
    alt: 'Modern glass building',
    tags: ['architecture', 'city', 'selected'],
    year: 2025,
    aspect: 'portrait',
  },
  {
    id: 2,
    src: 'https://images.unsplash.com/photo-1474487548417-781cb71495f3?w=900&q=80&auto=format&fit=crop',
    alt: 'Train station platform',
    tags: ['city', 'travel', 'selected'],
    year: 2024,
    aspect: 'landscape',
  },
  {
    id: 3,
    src: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=900&q=80&auto=format&fit=crop',
    alt: 'Atrium interior',
    tags: ['architecture', 'interior'],
    year: 2025,
    aspect: 'tall',
  },
  {
    id: 4,
    src: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=900&q=80&auto=format&fit=crop',
    alt: 'City street corner',
    tags: ['city', 'street'],
    year: 2023,
    aspect: 'square',
  },
  {
    id: 5,
    src: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=900&q=80&auto=format&fit=crop',
    alt: 'Mountain landscape',
    tags: ['nature', 'sunsets', 'selected'],
    year: 2024,
    aspect: 'landscape',
  },
  {
    id: 6,
    src: 'https://images.unsplash.com/photo-1514565131-fce0801e5785?w=900&q=80&auto=format&fit=crop',
    alt: 'Bridge and boat',
    tags: ['city', 'travel', 'water'],
    year: 2025,
    aspect: 'portrait',
  },
  {
    id: 7,
    src: 'https://images.unsplash.com/photo-1493246507139-91e8fad9978e?w=900&q=80&auto=format&fit=crop',
    alt: 'Coastline at dusk',
    tags: ['nature', 'sunsets', 'water', 'selected'],
    year: 2024,
    aspect: 'wide',
  },
  {
    id: 8,
    src: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=900&q=80&auto=format&fit=crop',
    alt: 'Road trip vista',
    tags: ['travel', 'nature', 'selected'],
    year: 2025,
    aspect: 'landscape',
  },
  {
    id: 9,
    src: 'https://images.unsplash.com/photo-1444723121867-7a241cacace9?w=900&q=80&auto=format&fit=crop',
    alt: 'City skyline',
    tags: ['city', 'architecture'],
    year: 2024,
    aspect: 'portrait',
  },
  {
    id: 10,
    src: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=900&q=80&auto=format&fit=crop',
    alt: 'Desert path',
    tags: ['nature', 'travel'],
    year: 2023,
    aspect: 'tall',
  },
  {
    id: 11,
    src: 'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=900&q=80&auto=format&fit=crop',
    alt: 'Foggy hills',
    tags: ['nature', 'sunsets', 'selected'],
    year: 2025,
    aspect: 'landscape',
  },
  {
    id: 12,
    src: 'https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=900&q=80&auto=format&fit=crop',
    alt: 'Night city lights',
    tags: ['city', 'night'],
    year: 2024,
    aspect: 'square',
  },
  {
    id: 13,
    src: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=900&q=80&auto=format&fit=crop',
    alt: 'Beach sunset',
    tags: ['sunsets', 'water', 'nature', 'selected'],
    year: 2025,
    aspect: 'wide',
  },
  {
    id: 14,
    src: 'https://images.unsplash.com/photo-1511818966892-d7d671e672a2?w=900&q=80&auto=format&fit=crop',
    alt: 'Modern architecture detail',
    tags: ['architecture', 'selected'],
    year: 2023,
    aspect: 'portrait',
  },
  {
    id: 15,
    src: 'https://images.unsplash.com/photo-1520962922320-2038eebab146?w=900&q=80&auto=format&fit=crop',
    alt: 'Cyclists on a city street',
    tags: ['city', 'street', 'selected'],
    year: 2024,
    aspect: 'landscape',
  },
  {
    id: 16,
    src: 'https://images.unsplash.com/photo-1496568816309-51bda608afc6?w=900&q=80&auto=format&fit=crop',
    alt: 'Apartment windows',
    tags: ['architecture', 'city'],
    year: 2023,
    aspect: 'portrait',
  },
  {
    id: 17,
    src: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=900&q=80&auto=format&fit=crop',
    alt: 'Lake reflection',
    tags: ['nature', 'water', 'selected'],
    year: 2025,
    aspect: 'wide',
  },
  {
    id: 18,
    src: 'https://images.unsplash.com/photo-1501785888041-af3bb730e367?w=900&q=80&auto=format&fit=crop',
    alt: 'Mountain lake overlook',
    tags: ['nature', 'travel'],
    year: 2024,
    aspect: 'landscape',
  },
  {
    id: 19,
    src: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=900&q=80&auto=format&fit=crop',
    alt: 'Sunlit forest ridge',
    tags: ['nature', 'sunsets', 'selected'],
    year: 2025,
    aspect: 'tall',
  },
  {
    id: 20,
    src: 'https://images.unsplash.com/photo-1448630360428-65456885c650?w=900&q=80&auto=format&fit=crop',
    alt: 'Ornate building facade',
    tags: ['architecture', 'city'],
    year: 2023,
    aspect: 'square',
  },
  {
    id: 21,
    src: 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=900&q=80&auto=format&fit=crop',
    alt: 'New York street view',
    tags: ['water', 'city', 'travel'],
    year: 2024,
    aspect: 'portrait',
  },
  {
    id: 22,
    src: 'https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?w=900&q=80&auto=format&fit=crop',
    alt: 'Starry night sky',
    tags: ['night', 'nature', 'selected'],
    year: 2025,
    aspect: 'wide',
  },
];

const captions = {
  1: 'A glass tower, from the sidewalk.',
  2: 'Waiting on the platform.',
  3: 'An atrium, all light and glass.',
  4: 'A corner I keep walking past.',
  5: 'Mountains, late in the day.',
  6: 'A bridge, and a boat underneath.',
  7: 'The coast, just after sunset.',
  8: 'Somewhere on a long drive.',
  9: 'The skyline, from far enough away.',
  10: 'A path through the desert.',
  11: 'Hills, almost gone in the fog.',
  12: 'The city, after dark.',
  13: 'The beach, while the sun drops.',
  14: 'A detail on a building.',
  15: 'Bikes, and the street around them.',
  16: 'Windows, stacked up the block.',
  17: 'A lake, holding the sky.',
  18: 'Looking down at a mountain lake.',
  19: 'A ridge, with the sun behind it.',
  20: 'A facade I stopped for.',
  21: 'A street in New York.',
  22: 'The sky, when it finally got dark.',
};

const ASPECT_RATIOS = {
  portrait: '3 / 4',
  landscape: '4 / 3',
  tall: '2 / 3',
  square: '1 / 1',
  wide: '16 / 10',
};

const Label = styled.h1`
  margin: 0 0 8px;
  font-family: var(--font-serif);
  font-size: 24px;
  font-weight: 500;
  letter-spacing: -0.02em;
  line-height: 1.2;
  text-align: left;
  color: var(--text);
`;

const Description = styled.p`
  margin: 0 0 24px;
  font-family: var(--font-sans);
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 1.55;
  text-align: left;
  color: var(--text-muted);
`;

const Masonry = styled.div`
  column-count: 4;
  column-gap: 28px;

  @media (max-width: 960px) {
    column-count: 3;
    column-gap: 24px;
  }

  @media (max-width: 640px) {
    column-count: 2;
    column-gap: 18px;
  }
`;

const Tile = styled.button`
  position: relative;
  display: block;
  width: 100%;
  margin: 0 0 28px;
  padding: 0;
  border: none;
  border-radius: 0;
  overflow: hidden;
  background: var(--surface);
  line-height: 0;
  text-align: left;
  cursor: pointer;
  break-inside: avoid;

  &:focus-visible {
    outline: 2px solid var(--text);
    outline-offset: 3px;
  }

  @media (max-width: 960px) {
    margin-bottom: 24px;
  }

  @media (max-width: 640px) {
    margin-bottom: 18px;
  }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-end;
  padding: 0.9rem 0.85rem;
  background: rgba(0, 0, 0, 0.5);
  opacity: ${(p) => (p.$open ? 1 : 0)};
  transition: opacity 0.22s ease;
  pointer-events: none;
`;

const Caption = styled.p`
  margin: 0;
  font-family: var(--font-sans);
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: -0.01em;
  color: #fff;
`;

const blink = keyframes`
  50% { opacity: 0; }
`;

const Caret = styled.span`
  display: inline-block;
  width: 1px;
  height: 0.85em;
  margin-left: 2px;
  background: #fff;
  vertical-align: -0.08em;
  animation: ${blink} 0.9s steps(1) infinite;
`;

const Photo = styled.img`
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: ${(p) => ASPECT_RATIOS[p.$aspect] || ASPECT_RATIOS.square};
  object-fit: cover;
  pointer-events: none;
  user-select: none;
`;

function usePrefersReducedMotion() {
  const [reduce, setReduce] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );

  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => setReduce(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);

  return reduce;
}

const TypedText = ({ text }) => {
  const reduce = usePrefersReducedMotion();
  const [count, setCount] = useState(reduce ? text.length : 0);

  useEffect(() => {
    if (reduce || count >= text.length) return undefined;
    const timer = window.setTimeout(() => setCount((current) => current + 1), 28);
    return () => window.clearTimeout(timer);
  }, [count, reduce, text]);

  return (
    <Caption>
      {text.slice(0, count)}
      {!reduce && <Caret aria-hidden="true" />}
    </Caption>
  );
};

const galleryItems = [...GALLERY_ITEMS].sort((a, b) => {
  const aSelected = a.tags.includes('selected') ? 0 : 1;
  const bSelected = b.tags.includes('selected') ? 0 : 1;
  if (aSelected !== bSelected) return aSelected - bSelected;
  return b.year - a.year;
});

export const GallerySection = ({ titleAs = 'h2' }) => {
  const [hoverId, setHoverId] = useState(null);
  const [pinnedId, setPinnedId] = useState(null);

  return (
    <>
      <Label as={titleAs}>Gallery</Label>
      <Description>
        A place for things I’ve been looking at.
        <br />
        Nothing formal. Just photos I wanted to keep.
      </Description>
      <Masonry>
        {galleryItems.map((item) => {
          const open = hoverId === item.id || pinnedId === item.id;
          return (
            <Tile
              key={item.id}
              type="button"
              aria-pressed={pinnedId === item.id}
              aria-label={captions[item.id]}
              onMouseEnter={() => setHoverId(item.id)}
              onMouseLeave={() => setHoverId((current) => (current === item.id ? null : current))}
              onFocus={() => setHoverId(item.id)}
              onBlur={() => setHoverId((current) => (current === item.id ? null : current))}
              onClick={() => setPinnedId((current) => (current === item.id ? null : item.id))}
            >
              <Photo src={item.src} alt="" $aspect={item.aspect} loading="lazy" />
              <Overlay $open={open}>
                {open && <TypedText key={item.id} text={captions[item.id]} />}
              </Overlay>
            </Tile>
          );
        })}
      </Masonry>
    </>
  );
};
